// extracted by mini-css-extract-plugin
export default {"avatarContainer":"style_avatarContainer__BhdUj","userInfo":"style_userInfo__EiuA-","eidtUserButton":"style_eidtUserButton__aBOmI"};